import { Spinner } from "@shopify/polaris";

// Centered spinner for Suspense fallbacks. fullScreen: fills the viewport
// (no shell yet); otherwise fills its parent (e.g. the portal content area).
const PageSpinner = ({ fullScreen = false }) => (
    <div
        style={{
            height: fullScreen ? "100svh" : "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }}
    >
        <Spinner accessibilityLabel="Loading" size="large" />
    </div>
);

export default PageSpinner;
